module.exports = __webpack_public_path__ + "static/media/collins.28e92852.jpg";